import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useCustomer } from '../../hooks/Features/useCustomer'
import AddCustomer from './AddCustomer'

export default function EditCustomer() {
  const { customer, getCustomer } = useCustomer()
  const params = useParams()
  useEffect(() => {
    getCustomer({ customerId: params.customerId })
  }, [params.customerId])

  return <> {customer ? <AddCustomer customer={customer} /> : <Loader />} </>
}
